export default "__VITE_ASSET__BuTeWmtg__"